<app-product-list [loading]="loading$ | async" [subtypes]="subtypes$ | async" [subtype]="subtype$ | async"
  (subtypeSelected$)="navigateToSubtype($event)"></app-product-list>
